export function TodayViewPrototypePage() {
  return (
    <iframe
      src={`${window.CORE_API_URL}/today`}
      id="todayView"
      title="Today View Prototype"
      width="100%"
      height="100%"
    />
  );
}
